import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
  },
  {
    path: 'search',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'route-detail/:lineId/:routeId',
    loadComponent: () => import('./pages/route-detail/route-detail.page').then(m => m.RouteDetailPage),
  },
  {
    path: 'gtfs-route-detail',
    loadComponent: () => import('./pages/gtfs-route-detail/gtfs-route-detail.page').then(m => m.GtfsRouteDetailPage),
  },
  {
    path: 'transfer-detail',
    loadComponent: () => import('./pages/transfer-detail/transfer-detail.page').then(m => m.TransferDetailPage),
  },
  {
    path: 'walking-detail',
    loadComponent: () => import('./pages/walking-detail/walking-detail.page').then(m => m.WalkingDetailPage),
  },
  {
    path: 'nearby',
    loadComponent: () => import('./pages/nearby/nearby.page').then(m => m.NearbyPage),
  },
  {
    path: 'lines',
    loadComponent: () => import('./pages/lines/lines.page').then(m => m.LinesPage),
  },
  {
    path: 'lines/:id',
    loadComponent: () => import('./pages/line-detail/line-detail.page').then(m => m.LineDetailPage),
  },
  {
    path: 'favorites',
    loadComponent: () => import('./pages/favorites/favorites.page').then(m => m.FavoritesPage),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage),
  },
  {
    path: 'my-qr',
    loadComponent: () => import('./pages/my-qr/my-qr.page').then(m => m.MyQrPage),
  },
  {
    path: 'scanner',
    loadComponent: () => import('./pages/scanner/scanner.page').then(m => m.ScannerPage),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
